import React__default from 'react';
import PropTypes from 'prop-types';

var propTypes = {
  /** Specify which other components you want to pass in */
  children: PropTypes.node.isRequired,
  /** Provide a caption for the 'fieldset' element that allows elemental grouping */
  legend: PropTypes.string.isRequired,
  /** The description refers to IDs of elements that describe field group. */
  ariaDescribedBy: PropTypes.string,
  /** Indicate if entered values are valid or invalid */
  isInvalid: PropTypes.bool
};
function FieldGroup(_ref) {
  var children = _ref.children,
    ariaDescribedBy = _ref.ariaDescribedBy,
    isInvalid = _ref.isInvalid,
    legend = _ref.legend;
  return /*#__PURE__*/React__default.createElement("fieldset", {
    "aria-invalid": isInvalid,
    "aria-describedby": ariaDescribedBy,
    className: "field-group"
  }, /*#__PURE__*/React__default.createElement("legend", {
    className: "screen-reader-text"
  }, legend), children);
}
FieldGroup.propTypes = propTypes;

export { FieldGroup as default };
//# sourceMappingURL=FieldGroup.js.map
